import { render, staticRenderFns } from "./ChooseCompany.vue?vue&type=template&id=85f5b5b4&scoped=true"
import script from "./ChooseCompany.vue?vue&type=script&lang=js"
export * from "./ChooseCompany.vue?vue&type=script&lang=js"
import style0 from "./ChooseCompany.vue?vue&type=style&index=0&id=85f5b5b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f5b5b4",
  null
  
)

export default component.exports